import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { logger } from "redux-logger";
import thunk from "redux-thunk";
import Root from "./containers/Root";
import reducer from "./reducers";
import * as actions from "./actions";
import { history } from "./history";
import "./index.css";

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

if (getParameterByName("access_token") !== null) {
  var redirect = "/";
  localStorage.setItem("access_token", getParameterByName("access_token"));
  if (localStorage.getItem("redirect")) {
    redirect = localStorage.getItem("redirect");
    localStorage.removeItem("redirect");
  }
  window.location = redirect;
}

const middleware =
  process.env.NODE_ENV === "production" ? [thunk] : [thunk, logger];

const enhancer =
  process.env.NODE_ENV === "production"
    ? applyMiddleware(...middleware)
    : compose(applyMiddleware(...middleware));

const store = createStore(reducer, enhancer);

window.store = store;
window.actions = actions;
window.history2 = history;

if (!localStorage.getItem("access_token")) {
  window.location = `${process.env.REACT_APP_API_ENDPOINT}/access/login`;
} else {
  store.dispatch(actions.identifyUser());

  ReactDOM.render(
    <React.StrictMode>
      <Root store={store} history={history} />
    </React.StrictMode>,
    document.getElementById("root")
  );
}
